import { render, staticRenderFns } from "./FieldWorkplaceTableExpand.vue?vue&type=template&id=2cbc6d05&scoped=true&"
import script from "./FieldWorkplaceTableExpand.vue?vue&type=script&lang=js&"
export * from "./FieldWorkplaceTableExpand.vue?vue&type=script&lang=js&"
import style0 from "./FieldWorkplaceTableExpand.vue?vue&type=style&index=0&id=2cbc6d05&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc6d05",
  null
  
)

export default component.exports